import aboutFeaturesCard1 from "../images/features/cryptobit-features-01.png";
import aboutFeaturesCard3 from "../images/features/cryptobit-features-03.png";
import aboutFeaturesCard4 from "../images/features/cryptobit-features-04.png";

const data = [
  {
    icon: aboutFeaturesCard1,
    title: "Join To A Crypto",
    text: "Multifunctional Partnershi And The Best Cryptocurrency.",
  },
  {
    icon: aboutFeaturesCard4,
    title: "Collect To Bitcoin",
    text: "Multifunctional Partnershi And The Best Cryptocurrency",
  },
  {
    icon: aboutFeaturesCard3,
    title: "Start The Selling",
    text: "Multifunctional Partnershi And The Best Cryptocurrency",
  },
  {
    icon: aboutFeaturesCard4,
    title: "Paid To Member",
    text: "Multifunctional Partnershi And The Best Cryptocurrency",
  }
];

export default data;
